import phSingleItem from "src/assets/static/img/main/loading-circle.svg";

export const Loading: React.FC<{ width?: number, height?: number }> = ({ width, height }) => (
    <div className="text-center">
        <img style={{ width, height, objectFit: "contain" }} alt="در حال بارگیری" src={phSingleItem} />
    </div>
);